module.exports = __webpack_public_path__ + "static/media/PE.3a3b530a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PE.svg
// module id = 2235
// module chunks = 7